/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function ForecastErrorFromJSON(json) {
    return ForecastErrorFromJSONTyped(json, false);
}
export function ForecastErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        mse: json['mse'],
        rmse: json['rmse'],
        mae: json['mae'],
        mase: json['mase'],
        mape: json['mape'],
        ravg: json['ravg'],
        rmax: json['rmax'],
    };
}
export function ForecastErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        mse: value.mse,
        rmse: value.rmse,
        mae: value.mae,
        mase: value.mase,
        mape: value.mape,
        ravg: value.ravg,
        rmax: value.rmax,
    };
}
